import { getToken, modifyAssignedDevicesList, modifyRequestReasonList } from "../../helper/common";
import agent from "../services/agent";
import {
  SET_RETURN_REQUESTS_LIST,
  SET_INITIAL_STATE,
  OPEN_RETURN_REQUESTS_ACTION_MODAL,
  CLOSE_RETURN_REQUESTS_ACTION_MODAL,
  SET_RETURN_REQUESTS_PENDING,
  SUBMIT_RETURN_REQUESTS_ACTION_PENDING,
  SUBMIT_RETURN_REQUESTS_ACTION_SUCCESS,
  SUBMIT_RETURN_REQUESTS_ACTION_ERROR,
  CLEAR_SUBMIT_RETURN_REQUESTS_ACTION_ERROR,
  SET_RETURN_REQUESTS_FORM,
  RETURN_REQUESTS_LIST_ERROR,
  SET_PAGE_SIZE_GLOBAL,
  SET_RETURN_REQUESTS_LIST_COUNT,
  RETURN_REQUESTS_LIST_COUNT_ERROR,
} from "../returnRequests/actionTypes";
import { showSnackbarStatus } from "../snackbar/actions";

export const setPageSizeGlobalRequest = (pageSize) => ({
  type: SET_PAGE_SIZE_GLOBAL,
  payload: { pageSize },
});

//-------------------------------RETURN_REQUESTS-LIST------------------------------------------
export const returnRequestsListError = (errorMessage) => ({
  type: RETURN_REQUESTS_LIST_ERROR,
  payload: { errorMessage },
});

export const returnRequestsListCountError = (errorMessage) => ({
  type: RETURN_REQUESTS_LIST_COUNT_ERROR,
  payload: { errorMessage },
});

export const setReturnRequestsPending = () => ({
  type: SET_RETURN_REQUESTS_PENDING,
});

const setReturnRequestsList = (returnRequestsOdata) => ({
  type: SET_RETURN_REQUESTS_LIST,
  payload: { returnRequestsOdata },
});
const setReturnRequestsListCount = (returnRequestsOdata) => ({
  type: SET_RETURN_REQUESTS_LIST_COUNT,
  payload: { returnRequestsOdata },
});

export const getReturnRequestsList = (page, pageSize, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchRequestedTo, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setReturnRequestsPending());
  getToken(dispatch).then((accesToken) => {
    agent.ReturnRequests.getReturnRequests(accesToken, page, pageSize, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchRequestedTo, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder)
      .then((returnRequestsList) => {
        dispatch(setReturnRequestsList(returnRequestsList));
      })
      .catch((err) => {
        console.log("getReturnRequests server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(returnRequestsListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(returnRequestsListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getReturnRequestsListCount = () => (dispatch) => {
  getToken(dispatch).then((accesToken) => {
    agent.ReturnRequests.getReturnRequestsCount(accesToken)
      .then((returnRequestsList) => {
        dispatch(setReturnRequestsListCount(returnRequestsList));
      })
      .catch((err) => {
        console.log("getReturnRequests server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(returnRequestsListCountError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(returnRequestsListCountError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//-------------------------------RETURN_REQUESTS-ACTIONS---------------------------------------
export const submitReturnRequestsActionPending = () => ({
  type: SUBMIT_RETURN_REQUESTS_ACTION_PENDING,
});

export const submitReturnRequestsActionSucces = () => ({
  type: SUBMIT_RETURN_REQUESTS_ACTION_SUCCESS,
});

export const submitReturnRequestsActionError = (errorMessage) => ({
  type: SUBMIT_RETURN_REQUESTS_ACTION_ERROR,
  payload: { errorMessage },
});

export const clearSubmitReturnRequestsActionError = () => ({
  type: CLEAR_SUBMIT_RETURN_REQUESTS_ACTION_ERROR,
});

export const setRequestActionFormInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const openReturnRequestsActionModal = () => ({
  type: OPEN_RETURN_REQUESTS_ACTION_MODAL,
});

export const closeReturnRequestsActionModal = () => ({
  type: CLOSE_RETURN_REQUESTS_ACTION_MODAL,
});

export const setReturnRequestsForm = (returnRequestsForm) => ({
  type: SET_RETURN_REQUESTS_FORM,
  payload: { returnRequestsForm },
});

export const submitReturnRequestsAction = () => (dispatch, getState) => {
  const currentState = getState();
  const { returnRequestsForm, pageSizeGlobal } = currentState && currentState.returnRequests;
  const { deviceKeys, reason, notes } = returnRequestsForm || {};
  if (!returnRequestsForm) {
    dispatch(submitReturnRequestsActionError("Please fill required details."));
    return;
  }

  const submitRequest = {
    ReturnReason: reason,
    Comments: notes ? notes.replaceAll("\n", " ") : null,
    DeviceKeys: deviceKeys,
  };

  dispatch(submitReturnRequestsActionPending());
  dispatch(clearSubmitReturnRequestsActionError());
  getToken(dispatch).then((accesToken) => {
    agent.ReturnRequests.addReturnRequest(accesToken, submitRequest)
      .then((response) => {
        const { errors, returned } = response;
        let errorMessage = "";
        let deletedDeviceArr;
        if (errors && Object.keys(errors).length !== 0) {
          Object.entries(errors).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');
            switch (key) {
              case "invalid_serial_number":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Device key ${value} are invalid. \n` : `Device key ${value} is invalid. \n`;

              case "device_key_assigned_to_customer":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned to customer. \n` : `Device ${value} has been assigned to customer. \n`;

              case "device_key_assigned_as_master_device":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned as master devices. \n` : `Device ${value} has been assigned as master device. \n`;

              case "return_request_already_sent":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} return requests are already sent. \n` : `Device ${value} return request is already sent. \n`;

              case "donot_have_access":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are inactive. \n` : `Device ${value} is inactive. \n`;

              case "donot_have_device":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are invalid. \n` : `Device ${value} is invalid. \n`;

              case "device_key_allocation_history_not_found":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are not found. \n` : `Device ${value} is not found. \n`;

              case "device_key_assigned_to_others":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned to others. \n` : `Device ${value} has been assigned to others. \n`;

              case "to_user_not_assign_the_device":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? ` Unable to find who is the assigned these devices ${value}. \n` : `Unable to find who is the assigned this device ${value}. \n`;

              default:
                return errorMessage += "Something went wrong. Try again later.";
            }
          });
          dispatch(submitReturnRequestsActionError(errorMessage));
        }
        if (returned && Object.keys(returned).length !== 0) {
          Object.entries(returned).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');
            if (key === "deviceS_RETURNED_SUCCESSFULLY") {
              const message = (deviceArray && deviceArray.length) > 1 ? `${deviceArray} return requests are successfully` : `${deviceArray} return request is sent successfully`;
              deletedDeviceArr = deviceArray;
              dispatch(showSnackbarStatus(message));
              dispatch(submitReturnRequestsActionSucces());
              dispatch(getReturnRequestsListCount());
              if (!errorMessage && errorMessage === "") {
                dispatch(closeReturnRequestsActionModal());
              }
              dispatch(getReturnRequestsList(1, pageSizeGlobal));
            }
          })
        }
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(submitReturnRequestsActionError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(submitReturnRequestsActionError(message));
        }
        console.log("submitReturnRequestsAction server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getAssignedDevicesForAsyncSelect = (searchValue, callback, isEndUser) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.ReturnRequests.getAssignedDevices(accessToken, searchValue, isEndUser)
      .then((groupsList) => {
        const devices = groupsList['value'];
        let groupsListOptions = modifyAssignedDevicesList(devices, isEndUser);
        callback && callback(groupsListOptions);
      })
      .catch((err) => {
        console.log("getAssignable groups for dropdown server error", err);
        callback && callback();
      });
  });
};
export const getReasonForAsyncSelect = (searchValue, callback, userEmail) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.ReturnRequests.getReasons(accessToken, searchValue, userEmail)
      .then((groupsList) => {
        const devices = groupsList['value'];
        let groupsListOptions = modifyRequestReasonList(devices);
        callback && callback(groupsListOptions);
      })
      .catch((err) => {
        console.log("getAssignable groups for dropdown server error", err);
        callback && callback();
      });
  });
};